module.exports = __webpack_public_path__ + "img/jxs-down-close.a18d0e5d.png";